"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _EditModule = _interopRequireDefault(require("./EditModule"));

var _ListModule = _interopRequireDefault(require("./ListModule"));

var _TableModule = _interopRequireDefault(require("./TableModule"));

var _GridModule = _interopRequireDefault(require("./GridModule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const templates = {
  "list": _ListModule.default,
  "table": _TableModule.default,
  "grid": _GridModule.default
};

const Module = (_ref) => {
  let _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "list" : _ref$variant,
      _ref$imageUrl = _ref.imageUrl,
      imageUrl = _ref$imageUrl === void 0 ? undefined : _ref$imageUrl,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? undefined : _ref$title,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? undefined : _ref$description,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? undefined : _ref$label,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? undefined : _ref$status,
      _ref$author = _ref.author,
      author = _ref$author === void 0 ? undefined : _ref$author,
      _ref$datetime = _ref.datetime,
      datetime = _ref$datetime === void 0 ? undefined : _ref$datetime,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "imageUrl", "title", "description", "label", "status", "author", "datetime", "children"]);

  if (props.editable && props.expanded) {
    return _react.default.createElement(_EditModule.default, _extends({}, props, {
      title: title
    }), children);
  }

  const ModuleTemplate = templates && templates[variant] || _ListModule.default;
  return _react.default.createElement(ModuleTemplate, _extends({}, props, {
    imageUrl: imageUrl,
    title: title,
    description: description,
    label: label,
    status: status,
    author: author,
    datetime: datetime
  }));
};

Module.propTypes = process.env.NODE_ENV !== "production" ? {
  variant: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  label: _propTypes.default.string,
  status: _propTypes.default.string,
  datetime: _propTypes.default.string,
  author: _propTypes.default.string,
  status: _propTypes.default.string
} : {};
var _default = Module;
exports.default = _default;
module.exports = exports.default;